import { render, staticRenderFns } from "./materialGRIC2.vue?vue&type=template&id=144d1abe&scoped=true"
import script from "./materialGRIC2.vue?vue&type=script&lang=js"
export * from "./materialGRIC2.vue?vue&type=script&lang=js"
import style0 from "./materialGRIC2.vue?vue&type=style&index=0&id=144d1abe&lang=scss&scoped=true"
import style1 from "./materialGRIC2.vue?vue&type=style&index=1&id=144d1abe&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d1abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('144d1abe')) {
      api.createRecord('144d1abe', component.options)
    } else {
      api.reload('144d1abe', component.options)
    }
    module.hot.accept("./materialGRIC2.vue?vue&type=template&id=144d1abe&scoped=true", function () {
      api.rerender('144d1abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/material/material-master-data/materialGRIC2.vue"
export default component.exports